import { sendGTMEvent } from "@next/third-parties/google";

import { getSessionId } from "./user-session-id";

export const dataLayerPush = (eventData: any, stateCode?: string) => {
  const dataLayerEventData = {
    ...eventData,
    tag_session_id: getSessionId(),
    platform: "NextJS",
    page_origin_name: globalThis?.document?.title,
    page_origin_url: globalThis?.location?.href,
    ...(stateCode && { state: stateCode }),
    scheduler_type:
      new URLSearchParams(globalThis.location.search).get("src") === "ops" ? "on page" : "bau",
  };
  sendGTMEvent(dataLayerEventData);
};
